import React from 'react'
import Typography from '@material-ui/core/Typography';

function NotFound() {
    return (
        <div>
            <Typography variant="h2" component="h2" gutterBottom>
                Page Not Found
            </Typography>
        </div>
    )
}

export default NotFound
